import { InAppMessageSchedule } from "../schedule/InAppMessageSchedule"
import { InAppMessageScheduleRequest } from "../schedule/InAppMessageScheduleRequest"

export class InAppMessageDelay {
  constructor(readonly schedule: InAppMessageSchedule, readonly requestedAt: number) {}

  get delayMillis(): number {
    return this.schedule.time.delayMillis(this.requestedAt)
  }

  static from(request: InAppMessageScheduleRequest): InAppMessageDelay {
    return new InAppMessageDelay(request.schedule, request.requestedAt)
  }

  /**
   * @override
   */
  toString(): string {
    return `InAppMessageDelay(dispatchId=${this.schedule.dispatchId}, requestedAt=${this.requestedAt})`
  }
}
